import { useUser } from "../../actions/authActions";
export default (
  links,
  setLinks,
  selectedPlatform,
  setSelectedPlatform,
  setLinksErrors
) => {
  const userId = localStorage.getItem("userId");
  const { data: userprofile, isError, error } = useUser(userId);
  const addLink = () => {
    if (!selectedPlatform) {
      setLinksErrors((prev) => ({
        ...prev,
        platform: "Please select a platform.",
      }));
      return;
    }
    if (links.some((link) => link.platform === selectedPlatform)) {
      setLinksErrors((prev) => ({
        ...prev,
        platform: "Platform already added.",
      }));
      return;
    }

    setLinks((prev) => [
      ...prev,
      { id: Date.now(), platform: selectedPlatform, url: "" },
    ]);
    setSelectedPlatform("");
    setLinksErrors((prev) => ({ ...prev, platform: "" }));
  };

  const updateLink = (id, url) => {
    setLinks((prev) =>
      prev.map((link) => (link.id === id ? { ...link, url } : link))
    );

    // Clear error if URL is now filled
    if (url.trim() !== "") {
      setLinksErrors((prev) => {
        const updated = { ...prev.links };
        delete updated[id];
        return { ...prev, links: updated };
      });
    }
  };

  const removeLink = (id) => {
    setLinks((prev) => prev.filter((link) => link.id !== id));
    setLinksErrors((prev) => {
      const updated = { ...prev.links };
      delete updated[id];
      return { ...prev, links: updated };
    });
  };

  const socialPlatforms = [
    "Facebook",
    "Instagram",
    "LinkedIn",
    "Threads",
    "Twitter-X",
    "TikTok",
    "YouTube",
  ];
  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">
          Error loading phone mobile: {error.message}
        </p>
      </div>
    );
  }
  return { userprofile, socialPlatforms, addLink, updateLink, removeLink };
};
